import React from "react";

export default function AddAppointmentModal({ show, onClose, appointmentForm, setAppointmentForm, onSubmit, doctors, patients }) {
  if (!show) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Schedule Appointment</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>Doctor *</label>
            <select required value={appointmentForm.doctor_id} onChange={(e) => setAppointmentForm({...appointmentForm, doctor_id: e.target.value})}>
              <option value="">Select Doctor</option>
              {doctors.map(d => (
                <option key={d.user_id} value={d.user_id}>{d.display_name || d.user_name}</option>
              ))}
            </select>
          </div>
          <div className="admin-row">
            <label>Patient *</label>
            <select required value={appointmentForm.patient_id} onChange={(e) => setAppointmentForm({...appointmentForm, patient_id: e.target.value})}>
              <option value="">Select Patient</option>
              {patients.filter(p => !appointmentForm.doctor_id || p.doctor_id === appointmentForm.doctor_id).map(p => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
          </div>
          <div className="admin-row">
            <label>Date *</label>
            <input type="date" required value={appointmentForm.date} onChange={(e) => setAppointmentForm({...appointmentForm, date: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>Time *</label>
            <input type="time" required value={appointmentForm.time} onChange={(e) => setAppointmentForm({...appointmentForm, time: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>Purpose</label>
            <input type="text" value={appointmentForm.purpose} onChange={(e) => setAppointmentForm({...appointmentForm, purpose: e.target.value})} />
          </div>
          <div className="admin-row">
            <label>Duration (minutes)</label>
            <input type="number" value={appointmentForm.duration_minutes} onChange={(e) => setAppointmentForm({...appointmentForm, duration_minutes: parseInt(e.target.value) || 30})} />
          </div>
          <div className="admin-row">
            <label>Notes</label>
            <textarea value={appointmentForm.notes} onChange={(e) => setAppointmentForm({...appointmentForm, notes: e.target.value})} />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">Create Appointment</button>
            <button type="button" className="btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
